import { LoginPage } from "./LoginPage";

export const StartPage = () => <LoginPage />;
